import { AxiosResponse } from "axios";
import get from "lodash-es/get";

import api from "app/api/requests/PageContent";
import getToken from "app/api/getToken";
import { IPageContent } from "app/api/types";

export const DEL_PAGE_CONTENT_REQUEST = "DEL_PAGE_CONTENT_REQUEST";
export const DEL_PAGE_CONTENT_SUCCESS = "DEL_PAGE_CONTENT_SUCCESS";
export const DEL_PAGE_CONTENT_FAIL = "DEL_PAGE_CONTENT_FAIL";

export const delPageContent = (id: IPageContent["pageId"]) => (
  dispatch: any
): any => {
  dispatch({ type: DEL_PAGE_CONTENT_REQUEST });

  const token = getToken();

  return api
    .delPageContent(token, id)
    .then((response: AxiosResponse) => {
      const pageContent: IPageContent[] = get(response, "data", {});
      dispatch({ type: DEL_PAGE_CONTENT_SUCCESS });

      return pageContent;
    })
    .catch(err => {
      dispatch({
        type: DEL_PAGE_CONTENT_FAIL
      });
      throw get(err, "response.data.errors", {});
    });
};
